import styled from 'styled-components'
import { StyledFormBuilder } from '../../components/form/_styledtemp'

export const StyledContactUs = styled.div`
  @media only screen and (max-width: 600px) {
    ${StyledFormBuilder} {
      margin: 20px 30px;
    }
  }
`
